/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { StepCodes } from '@core/config/step-codes';
import { POSITION_ROUTES_TREE } from '@core/config/routes-tree';
import { RouteCodes } from '@core/config/route-codes';
import { StepConfigModel } from '@models/wizard/steps-config.model';

/**
 * L'oggetto configura per ogni step code il path della pagina da visualizzare.
 *
 * Il comportamento di default compone il path finale nel seguente modo
 *  "position/<path>"
 * Se è necessario definire un path diverso è possibile mettere a true
 * la proprietà "absolutePath", in questo modo il path finale terrà conto
 * esclusivamente di quanto dichirato nella proprietà "path"
 */

export const STEPS_CONFIG: {
  [stepCode: string]: StepConfigModel;
} = {
  [StepCodes.consents]: {
    path: POSITION_ROUTES_TREE[RouteCodes.consents].path
  },
  [StepCodes.documentsRequest]: {
    path: POSITION_ROUTES_TREE[RouteCodes.documentsRequest].path
  },
  [StepCodes.additionalDocumentsRequest]: {
    path: POSITION_ROUTES_TREE[RouteCodes.documentsRequest].path
  },
  [StepCodes.resolution]: {
    path: POSITION_ROUTES_TREE[RouteCodes.resolution].path
  },
  [StepCodes.quotationCalculation]: {
    path: POSITION_ROUTES_TREE[RouteCodes.quotationCalculate].path
  },
  [StepCodes.quotation]: {
    path: POSITION_ROUTES_TREE[RouteCodes.quotation].path
  },
  [StepCodes.obligations]: {
    path: POSITION_ROUTES_TREE[RouteCodes.obligations].path
  },
  [StepCodes.recognition]: {
    path: POSITION_ROUTES_TREE[RouteCodes.recognition].path
  },
  [StepCodes.adequacy]: {
    path: POSITION_ROUTES_TREE[RouteCodes.adequacy].path
  },
  [StepCodes.contractSigning]: {
    path: POSITION_ROUTES_TREE[RouteCodes.contractSigning].path
  },
  [StepCodes.waitingShort]: {
    path: POSITION_ROUTES_TREE[RouteCodes.waiting].path,
    params: { waitingType: 'short' }
  },
  [StepCodes.waitingLong]: {
    path: POSITION_ROUTES_TREE[RouteCodes.waiting].path,
    params: { waitingType: 'long' }
  },
  [StepCodes.customerInfo]: {
    path: POSITION_ROUTES_TREE[RouteCodes.customerInfo].path
  },
  [StepCodes.financialData]: {
    path: POSITION_ROUTES_TREE[RouteCodes.financialData].path
  },
  [StepCodes.notes]: {
    path: POSITION_ROUTES_TREE[RouteCodes.notes].path
  },
  [StepCodes.tfrRelease]: {
    path: POSITION_ROUTES_TREE[RouteCodes.tfrReleaseQuote].path
  },
  [StepCodes.ceilingReduction]: {
    path: POSITION_ROUTES_TREE[RouteCodes.ceilingReduction].path
  },
  [StepCodes.atcChoice]: {
    path: POSITION_ROUTES_TREE[RouteCodes.atcChoice].path
  },
  [StepCodes.dataCollection]: {
    path: POSITION_ROUTES_TREE[RouteCodes.dataCollection].path
  },
  [StepCodes.usesReport]: {
    path: POSITION_ROUTES_TREE[RouteCodes.usesReport].path
  },
  [StepCodes.withdraw]: {
    path: POSITION_ROUTES_TREE[RouteCodes.withdraw].path
  }
};
